// eslint-disable-next-line no-restricted-imports -- so we can re-export the typed hooks
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { WebReducerState } from '~/reducers/types';

// FIXME: use `typeof store.dispatch` to type this hook, once we fix our store types
export const useAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<WebReducerState> =
  useSelector;
